import React from 'react';
import logoIcon from '../../assets/images/M_Multicolor.svg';
import logoFull from '../../assets/images/iaai-logo-horizontal-color-dark-mode.svg';

interface MarketingSidebarProps {
  collapsed: boolean;
  onToggle: () => void;
  onNewChat: () => void;
}

const MarketingSidebar: React.FC<MarketingSidebarProps> = ({ collapsed, onToggle, onNewChat }) => {
  return (
    <aside className={`mkt-sidebar-left ${collapsed ? 'mkt-sidebar-left--collapsed' : ''}`}>
      <div className="mkt-sidebar-left__top">
        {/* Brand */}
        <div className="mkt-sidebar-left__brand">
          <div className="mkt-sidebar-left__logo-wrap">
            {collapsed ? (
              <img src={logoIcon} alt="InsuranceAgency.AI" style={{ width: 54, height: 56, objectFit: 'contain', display: 'block' }} />
            ) : (
              <img src={logoFull} alt="InsuranceAgency.AI" style={{ width: '100%', maxWidth: 180, height: 'auto', maxHeight: 48, objectFit: 'contain', objectPosition: 'left center', display: 'block' }} />
            )}
          </div>
          {!collapsed && (
            <button className="mkt-sidebar-left__toggle mkt-sidebar-left__toggle--inline" onClick={onToggle} aria-label="Collapse sidebar">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
          )}
        </div>
        {collapsed && (
          <button className="mkt-sidebar-left__toggle mkt-sidebar-left__toggle--below" onClick={onToggle} aria-label="Expand sidebar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        )}

        {/* Chat nav */}
        <nav className="mkt-sidebar-left__section" aria-label="Chat navigation">
          {!collapsed && <div className="mkt-sidebar-left__section-label">CHAT</div>}
          <button className="mkt-sidebar-left__item mkt-sidebar-left__item--active" aria-label="AI Chat">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
            </svg>
            {!collapsed && <span>AI Chat</span>}
          </button>
          <button className="mkt-sidebar-left__item mkt-sidebar-left__item--accent" onClick={onNewChat} aria-label="New Chat">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M12 5v14M5 12h14" />
            </svg>
            {!collapsed && <span>New Chat</span>}
          </button>
        </nav>
      </div>

      {/* Footer */}
      <div className="mkt-sidebar-left__footer">
        <a
          className="mkt-sidebar-left__item"
          href="/login"
          aria-label="Sign In"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          {!collapsed && <span>Sign In</span>}
        </a>
      </div>
    </aside>
  );
};

export default MarketingSidebar;
